import { render, staticRenderFns } from "./SolicitacaoEditarMarcacoes.vue?vue&type=template&id=c3688736&scoped=true&"
import script from "./SolicitacaoEditarMarcacoes.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoEditarMarcacoes.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoEditarMarcacoes.vue?vue&type=style&index=0&id=c3688736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3688736",
  null
  
)

export default component.exports